import React, { useState } from 'react';
import apiClient from '../../Services/ApiClient';
import { useEffectAsync } from '../../helpers';
import { CASE } from '../../Modules/Case/Graphql/case.graphql';
import MedicalReportDetailDefaultForm from './MedicalReportDetailDefaultForm';
import useTranslation from '../../Hooks/useTranslation';
import { firstUpperString } from '../FirstUpper';
import { FormValues } from '../../Modules/MagicForm/Interfaces/FormValues';
import { useAppContext } from '../../Services/AppContext';

interface MedicalReportDetailDefaultProps {
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	caseId?: string;
	onSuccess?: (values: FormValues) => void;
	defaultData?: any;
	customSuccess?: (values: FormValues) => void;
}

interface MedicalReportDefaults {
	title: string;
	contactSpecialist: boolean;
	text?: string;
}

const MedicalReportDetailDefault: React.FC<MedicalReportDetailDefaultProps> = ({
	patientId,
	defaultData,
	caseId,
	onSuccess,
	customSuccess,
}) => {
	const [initialized, setInitialized] = useState(true);
	const [isMeddiCase, setIsMeddiCase] = useState(false);
	const { t } = useTranslation();
	const { globalTemplate } = useAppContext();

	const [defaultValues, setDefaultValues] = useState<MedicalReportDefaults>({
		title: firstUpperString(t('base.shared.medicalReport') + ''),
		contactSpecialist: false,
		diagnoses: [{ diagnose: { label: undefined, value: undefined } }],
		...defaultData,
	});

	// @ts-ignore
	useEffectAsync(async () => {
		await loadCaseData();
	}, []);

	const loadCaseData = async () => {
		if (caseId) {
			const { data } = await apiClient.graphql({
				query: CASE,
				variables: {
					id: caseId,
				},
				fetchPolicy: 'network-only',
			});
			setIsMeddiCase(data.case?.isMeddi && globalTemplate === 'default');
		}
	};

	if (!initialized) {
		return null;
	}

	return (
		<MedicalReportDetailDefaultForm
			onSubmit={customSuccess ? customSuccess : onSuccess}
			isMeddiCase={isMeddiCase}
			defaultData={defaultValues}
			patientId={patientId}
		/>
	);
};

export default MedicalReportDetailDefault;
